export default __webpack_public_path__ + "ada6a9fb1f64a6bb8c5e00c00ee1f97d.png";